module.exports = "/databas/images/circle_marker.png?6049c6297545ff66fbde660d697eadc0";